<template>
    <v-form name="add-alert-form">
        <div class="grid"
             style="margin-top:5px">
            <FormMultiselect fieldName="user_id"
                             label="User"
                             size="6"
                             validation="required"
                             :isFocus="true"
                             :options="select?.users"
                             v-model:field="alertData.user_id" />
            <FormSelect fieldName="dcttype_id"
                        label="Alert type"
                        size="3"
                        validation="required"
                        :options="select?.dct_alert_types"
                        v-model:field="alertData.dcttype_id" />

            <FormCalendar fieldName="show_alert_date"
                          label="Date, time"
                          size="3"
                          validation="required"
                          showTime
                          hourFormat="24"
                          dateFormat="yy-mm-dd"
                          :minDate="new Date()"
                          :showIcon="true"
                          v-model:field="alertData.show_alert_date" />

        </div>
        <div class="grid">
            <FormEditor fieldName="message"
                        class="mb-6"
                        label="Message"
                        validation="required"
                        v-model:field="alertData.message" />
        </div>
        <div style="display:block;margin-top:20px"></div>
        <div class="grid">
            <Button severity="success"
                    style="margin:0 8px"
                    @click="addAlert"
                    class="bg-secondary-500 hover:bg-gray-200 text-white hover:text-gray-600 font-medium py-1 px-2.5 rounded-md border border-gray-200 hover:border-gray-300 transition-colors duration-150 flex items-center gap-2">
                <i class="pi pi-bell"></i>
                {{ __('Add alert') }}
            </Button>
            <Button severity="secondary"
                    style="margin:0 8px"
                    @click="cancel"
                    class="bg-white hover:bg-rose-50 text-rose-600 font-medium py-1 px-3 rounded-md border border-rose-200 hover:border-rose-300 transition-colors duration-150">
                <i class="pi pi-ban"></i>
                {{ __('Cancel') }}
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useForm } from '@inertiajs/vue3'

import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormSelect from '@crud/FormSelect.vue'

import FormStaticText from '@crud/FormStaticText.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import Button from 'primevue/button';
import ChangeLog from '@crud/ChangeLog.vue'
import { prepareSelect, validation } from '@pages/Helper/crud_utils.js'
import { __, screenMessage } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isAddAlertDialogOpen = defineModel('isAddAlertDialogOpen')

const options = ["users", "dct_alert_types"];
const alertData = ref({
    user_id: null,
    dcttype_id: null,
    show_alert_date: nowPlusOneDay(),
    message: '',
    source_table: null,
    source_id: null,
});
const select = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    select.value = await prepareSelect(options)
})

// -----------------------------------------------------

const cancel = () => {
    isAddAlertDialogOpen.value = false
}

// -----------------------------------------------------

function nowPlusOneDay() {
    const now = new Date();
    now.setDate(now.getDate() + 1);
    return now;
}

// -----------------------------------------------------

const addAlert = () => {
    const formData = {
        ...alertData.value,
        source_table: props.formProps.source_table ?? null,
        source_id: props.formProps.source_id ?? null,
    };

    if (!validation(formData, "add-alert-form")) {
        return false
    }

    useForm(formData).post(route('alert-add'), {
        preserveState: true,
        preserveScroll: true,
        forceFormData: true,
        onError: (errors) => {
            console.error(errors)
        },
        onSuccess: () => {
            isAddAlertDialogOpen.value = false
            const message = {
                message: "Alert was added successfully",
                title: "Information",
                type: "info",
                position: "center",
                timeout: 3,
            };
            screenMessage(message);
        },
        onFinish: () => {
        }
    })


}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
